import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { HiX } from "react-icons/hi";
import { getConsent, setConsent } from "@/lib/consent";

export default function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = getConsent();
    if (!consent) {
      const timer = setTimeout(() => setIsVisible(true), 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptAll = () => {
    setConsent("all");
    setIsVisible(false);
  };

  const acceptEssential = () => {
    setConsent("essential");
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: "spring", damping: 25, stiffness: 200 }}
          className="fixed bottom-0 left-0 right-0 z-[200] p-4 sm:p-6"
        >
          <div className="max-w-4xl mx-auto bg-gray-900/95 backdrop-blur-2xl rounded-2xl sm:rounded-3xl border border-white/10 p-5 sm:p-6 shadow-[0_-10px_40px_rgba(0,0,0,0.5)]">
            <button
              onClick={acceptEssential}
              className="absolute top-3 right-3 sm:top-4 sm:right-4 w-8 h-8 rounded-full bg-white/10 flex items-center justify-center text-white/60 hover:text-white hover:bg-white/20 transition-colors"
              aria-label="Close cookie banner"
            >
              <HiX className="w-4 h-4" />
            </button>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6">
              <div className="flex-1 pr-6 sm:pr-0">
                <h3 className="text-white font-bold text-base sm:text-lg mb-1 font-heading">Cookie Notice</h3>
                <p className="text-gray-400 text-sm leading-relaxed">
                  We use cookies to enhance your browsing experience and analyse website traffic.
                  By clicking "Accept All", you consent to analytics and performance cookies.
                  See our{" "}
                  <Link to="/privacy" className="text-white underline hover:text-gray-300 transition-colors">
                    Privacy Policy
                  </Link>{" "}
                  for more details.
                </p>
              </div>

              <div className="flex gap-3 w-full sm:w-auto shrink-0">
                <button
                  onClick={acceptEssential}
                  className="flex-1 sm:flex-none px-5 py-2.5 rounded-xl text-sm font-bold text-white bg-white/10 border border-white/20 hover:bg-white/20 transition-colors min-h-[44px]"
                >
                  Essential Only
                </button>
                <button
                  onClick={acceptAll}
                  className="flex-1 sm:flex-none px-5 py-2.5 rounded-xl text-sm font-bold text-black bg-white hover:bg-gray-200 transition-colors min-h-[44px]"
                >
                  Accept All
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
